import React, { useState, useRef, useEffect } from 'react';
import 'primereact/resources/themes/lara-light-blue/theme.css'
import '../../styles/global.css';
import '../../styles/pages/CadastroFarm.css';
import '@geoman-io/leaflet-geoman-free'
import * as mapas from '../../utils/mapas';
import { Messages } from 'primereact/messages';
import { Button } from 'primereact/button';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Calendar } from 'primereact/calendar';
import GrassIcon from '@mui/icons-material/Grass';
import EventIcon from '@mui/icons-material/Event';
import PollIcon from '@mui/icons-material/Poll';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { InputNumber } from 'primereact/inputnumber';
import API from '../../api/API'
import { DataTable } from 'primereact/datatable';
import { PlantioType, LoteType, newPlantio, mapStringToAny, newPlano, PessoaType, ImovelType, PlanoType, STATUS } from '../../db/Orm';
import { PiPlantFill } from "react-icons/pi";
import { MdMap } from "react-icons/md";
import { Badge } from 'primereact/badge';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Column } from 'primereact/column';
import { Divider } from 'primereact/divider';
import { LotesSelect } from '../components/LotesSelect';
import { ToggleButton } from 'primereact/togglebutton';
import { FaArrowUpFromWaterPump } from 'react-icons/fa6';
import { GiWaterDrop } from 'react-icons/gi';
import { FaTimes, FaWater } from 'react-icons/fa';
import { AutoComplete, AutoCompleteCompleteEvent } from 'primereact/autocomplete';
import Embrapa from '../../api/Embrapa';
import BadgeIcon from '@mui/icons-material/Badge';
import { InputMaskCompleteEvent } from 'primereact/inputmask';
import { PiIdentificationBadgeFill } from 'react-icons/pi';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import axios, { AxiosError } from 'axios';
import DocumentFileUpload from '../components/DocumentFileUpload';
import Auth from '../../auth/Authenticator';
import InputCpfCnpj from '../components/InputCpfCnpj';

export enum CadastroPlantioConfig {
    CADASTRO_PRODUTOR,
    APROVACAO_RT,
    APROVACAO_AIBA,
    APROVACAO_ADAB,
    APENAS_VISUALIZACAO,
}

type CadastroPlantioProps = {
    visible: boolean
    propriedades: Array<ImovelType>
    propriedade?: ImovelType
    setVisible: Function
    config: CadastroPlantioConfig
    plano: PlanoType | null
    plantios?: PlantioType[]
    onCadastroSucesso?: ()=>Promise<void>|(()=>void)
}
type RTPessoaType = {
    id: number
    nome_razao: string
    status_rt: string | null
    cpf_cnpj: string
    user_id: number
}

// type PlantioCadastroType = PlantioType & {
//     lotes: Array<LoteType>
// }

export default function CadastroPlantio(props: CadastroPlantioProps) {
    const auth = Auth.useAuth();
    const [plantio, setPlantio] = useState<PlantioType>(newPlantio());
    const [plantios, setPlantios] = useState<Array<PlantioType>>(props.plantios || []);
    const msgs = useRef<any>(null);
    const [culturas, setCulturas] = useState<Array<any>>([])
    const [listaCulturas, setListaCulturas] = useState<Array<string>>([])
    const [variedades, setVariedades] = useState<Array<any>>([])
    const [listaVariededes, setListaVariedades] = useState<Array<string>>([])
    const mapCulturasToCode = useRef<mapStringToAny>({})
    const mapCultivarToVariedade = useRef<mapStringToAny>({})
    const [lotes, setLotes] = useState<Array<any>>([])
    const [waiting, setWaiting] = useState<boolean>(false)
    const [countLotes, setCountLotes] = useState<number>(0)
    const [lockPropriedade, setLockPropriedade] = useState<boolean>(false)
    const [pessoaRT, setPessoaRT] = useState<RTPessoaType | null>(null)
    const [drt, setDrt] = useState<number | null>(null)
    const [files, setFiles] = useState<Array<any>>([])
    const [cpfNome, setCpfNome] = useState<string>('')
    const [campoCpfCnpj, setCampoCpfCnpj] = useState<string>('')
    const [tipoRT, setTipoRT] = useState<'cpf' | 'cnpj'>('cpf');

    // console.log('Propriedades no CadastroPlantio', props.propriedades)  

    const carregarCulturas = async () => {
        //console.log('carregarCulturas')
        const apikey = Embrapa.keys.agritec
        const url = Embrapa.urls.agritec_culturas
        let json: any = {}
        let data: Array<any> = []
        try {
            json = await Embrapa.fetchOrLoad(url, apikey)
            data = await json.data as Array<any>
        } catch (error) {
            console.error('Erro ao carregar culturas da Embrapa:', error)
        }
        setCulturas(data)
        data.forEach((val) => {
            mapCulturasToCode.current[val.nome] = val.id
        })
        //console.log('culturas', data)
        //console.log('mapCulturasToCode', mapCulturasToCode.current)
    }
    const carregarVariedades = async (id: number) => {
        const apikey = Embrapa.keys.agritec
        const url = `${Embrapa.urls.agritec_cultivares}?safra=2024-2025&idCultura=${id}&uf=BA&dataAtualizacao=2024-01-01`
        //console.log('URL', url)
        const json = await Embrapa.fetchOrLoad(url, apikey)
        const data: Array<any> = json.data
        setVariedades(data)
        //console.log('Variedades', data)
        mapCultivarToVariedade.current = {}
        data.forEach((variedade) => { mapCultivarToVariedade.current[variedade.cultivar] = variedade })
        //console.log('mapCultivarToVariedade', mapCultivarToVariedade.current)
    }
    function changeFieldGeneric(event: any) {
        const { value, name } = event.target;
        //console.log('ChangeField', name, value)
        setPlantio({ ...plantio, [name]: value })
    }
    function changeFieldCultura(event: any) {
        changeFieldGeneric(event)
        const code = mapCulturasToCode.current[event.target.value]
        typeof code === 'number' && carregarVariedades(code)
    }
    function changeFieldVariedade(event: any) {
        //console.log(event, mapCultivarToVariedade.current)
        const variedadeObject = mapCultivarToVariedade.current[event.target.value]
        if (!variedadeObject) {
            changeFieldGeneric(event)
            return
        }
        //console.log(variedadeObject)
        plantio.produtividade = variedadeObject.potencialProdutivo
        setPlantio({ ...plantio, produtividade: variedadeObject.potencialProdutivo, variedade: event.target.value })
    }
    function changeFieldDRT(event: any) {
        setDrt(event.value)
    }
    function onCpfCnpjSetValue(value: string) {
        setCampoCpfCnpj(value)
        const digits = value.replace(/\D/g, '');
        if ((tipoRT === 'cpf' && digits.length !== 11) || (tipoRT === 'cnpj' && digits.length !== 14)) {
            setCpfNome('')
            setPessoaRT(null);
        }
    }
    type PartialEvent = {value: string|null|undefined}
    async function completeFieldCPF(event: InputMaskCompleteEvent|PartialEvent) {
        setCpfNome('Carregando')
        let req
        try {
            req = await axios.get(API.url + 'busca-rt/?' + event.value, API.getAuthHeaders())
        } catch (error) {
            if (error instanceof AxiosError){
                setCpfNome('Ocorreu um erro na busca deste CPF/CNPJ')
            }
            return
        }
        //console.log('Request', req)
        if (!(req.data instanceof Array)) return
        const pessoa = req.data[0] as RTPessoaType | undefined
        if (pessoa) {
            setPessoaRT(pessoa)
            switch (pessoa.status_rt){
                case STATUS.APROVADO:
                    setCpfNome(pessoa.nome_razao)
                    break
                case STATUS.NOVO:
                    setCpfNome(`${pessoa.nome_razao} ainda não foi aprovado como responsável técnico.`)
                    break
                default:
                    setCpfNome(`${pessoa.nome_razao} não é responsável técnico.`)
            }
        } else {
            setCpfNome('Este CPF/CNPJ não está cadastrado')
        }
    }
    const addPlantio = () => {
        //console.log('Plantio', plantio)
        if (lotes.length === 0) return
        const cadPlantio: PlantioType = { ...plantio, lotes: [...lotes] }
        cadPlantio.lotes?.sort((a, b) => (a.id || 1) - (b.id || 2))
        setPlantios([...plantios, cadPlantio])
        setPlantio(newPlantio())
        setVariedades([])
        setListaVariedades([])
    }
    const plantioTemplate = (plantio: PlantioType) => {
        return plantio.data?.toLocaleDateString('pt-BR')
    }
    const produtividadeTemplate = (plantio: PlantioType) => {
        return plantio.produtividade?.toLocaleString('pt-BR')
    }
    const irrigacaoTemplate = (plantio: PlantioType) => {
        return <>
            <div style={{ display: 'flex', gap: '1em' }}>
                {plantio.irrigacao_fluvial && <FaWater size={'2em'}></FaWater>}
                {plantio.irrigacao_poco && <FaArrowUpFromWaterPump size={'2em'}></FaArrowUpFromWaterPump>}
                {!(plantio.irrigacao_fluvial || plantio.irrigacao_poco) && <FaTimes size={'2em'}></FaTimes>}
            </div>
        </>
    }
    const deletePlantio = (plantio: PlantioType) => {
        setPlantios(plantios.filter(p => p !== plantio))
    }
    const actionBodyTemplate = (plantio: PlantioType) => {
        return <Button severity="danger" icon="pi pi-times" rounded onClick={() => deletePlantio(plantio)} />;
    };
    const lotesTemplate = (plantio: PlantioType) => {
        return plantio.lotes?.reduce((acum, lote, index, lotes) => {
            return acum + lote.id + (index < lotes.length - 1 ? ', ' : '')
        }, '')
    }

    const [propriedade, setPropriedade] = useState<ImovelType | null>(props.propriedade ? props.propriedade : null)
    const [loading, setLoading] = useState<boolean>(false)
    const mapRef = useRef<any>()
    const [map, setMap] = useState<any>(null)

    useEffect(() => {
        try {
            if (props.visible && mapRef.current) {
                if (mapRef.current && !map) {
                    const map = mapas.createMapOnBahia(mapRef)
                    mapas.refreshingMap(map, setLoading)
                    setMap(map)
                }
                setTimeout(() => {
                }, 100); // Pequeno atraso para garantir que o Dialog esteja completamente renderizado
            }
        } catch (e: any) { console.log('Error:', e) }
    }, [props.visible, mapRef.current]);

    useEffect(() => {
        console.log('Propriedade lock', props.propriedade)
        setLockPropriedade(plantios.length !== 0 || props.propriedade !== undefined)
    }, [plantios])

    async function cadastrar(event: React.FormEvent) {
        event.preventDefault();
        if (props.plano){
            // console.log('Cadastro em plano', props.plano, plantios)
            setWaiting(true)
            const success = await cadastrarEmPlano(props.plano)
            setWaiting(false)
            if (success) {
                toast.current?.show({ severity: 'success', summary: 'Cadastro de Plantio', detail: 'Cadastro bem sucedido' })
                resetCadastroPlantio()
                await props.onCadastroSucesso?.()
            } else {
                toast.current?.show({ severity: 'error', summary: 'Cadastro de Plantio', detail: 'Erro ao cadastrar plantio' })
            }
            return
        }
        var plano = newPlano()
        plano.safra = 1
        plano.propriedade = propriedade
        plano.responsavel_tecnico = {id: pessoaRT?.user_id}
        plano.drt = drt?.toString() || ''
        plano.doc_drt = files[0]
        // console.log('Cadastro Plano Completo', plano, plantios)
        setWaiting(true)
        const req = await API.cadastrarPlanoCompleto(plano, plantios)
        console.log('Req cadastro completo:', req)
        let erro: boolean = req.ok === false
        let errorMsg: string = req.detail
        setWaiting(false)
        if (erro) {
            toast.current?.show({ severity: 'error', summary: 'Cadastro de Plantio', detail: errorMsg })
        } else {
            toast.current?.show({ severity: 'success', summary: 'Cadastro de Plantio', detail: 'Cadastro bem sucedido' })
            resetCadastroPlantio()
            await props.onCadastroSucesso?.()
        }
    }
    async function cadastrarEmPlano(plano: PlanoType){
        console.log('plano', plano)
        plantios.forEach((plantio)=>{
            plantio.plano = plano
        })
        console.log('plantios', plantios)
        try {
            const rtUserId = pessoaRT?.user_id
            if (typeof(rtUserId) === 'number' && plano.responsavel_tecnico?.id !== rtUserId && plano.id !== null){
                const resp = await API.alterarRTPlano(plano.id, rtUserId)
                if (resp instanceof Error) return false
            }
            for (let plantio of plantios){
                if (!plantio.lotes || !plantio.lotes.length) throw Error()
                const plantioCadastrado = await API.cadastrarPlantio(plantio)
                console.log('plantioCadastrado', plantioCadastrado)
                if (!plantioCadastrado) throw Error()
                const plantioLotes = await API.cadastrarPlantioLote(plantioCadastrado, plantio.lotes)
                console.log('plantioLotes', plantioLotes)
            }
            return true
        } catch (error) {
            return false
        }
    }
    const resetCadastroPlantio = () => {
        console.log('Resetando cadastro de plantio')
        setPlantios([])
        setCampoCpfCnpj('')
        setCpfNome('')
        setDrt(null)
        setPessoaRT(null)
        setFiles([])
        setPlantio(newPlantio())
        console.log('Resetando cadastro de plantio')
    }
    const onFocusCultura = async (e: React.FocusEvent<HTMLInputElement, Element>) => {
        //console.log('culturas', culturas)
        culturas.length === 0 && await carregarCulturas()
    }

    const [errorNome, setErrorNome] = useState('')
    const toast = useRef<Toast | null>(null);


    const headerElement = (
        <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
            <PiPlantFill />
            <span style={{ marginLeft: 10, marginRight: 10, width: '100%' }}>Cadastro de Plantio</span>
        </div>
    )

    const footerElement = (
        <div>
            <Button label={waiting ? '' : 'CADASTRAR'} icon={waiting ? '' : 'pi pi-send'} iconPos='right' severity="success" rounded onClick={cadastrar} disabled={plantios.length===0||!pessoaRT||waiting} >{waiting && <ProgressSpinner style={{ width: '20px', height: '20px' }} strokeWidth="8" />}</Button>
        </div>
    )

    const searchCultura = (event: AutoCompleteCompleteEvent) => {
        setTimeout(() => {
            let _filteredCulturas: Array<string> = culturas.map(cultura => cultura.nome.toUpperCase())
            _filteredCulturas = _filteredCulturas.filter(nome => nome.includes(event.query.toUpperCase()))
            setListaCulturas(_filteredCulturas)
        }, 500);
    }
    const searchVariedade = (event: AutoCompleteCompleteEvent) => {
        setTimeout(() => {
            let _filteredVariedades: Array<string> = variedades.map(v => v.cultivar)
            _filteredVariedades = _filteredVariedades.filter(nome => nome.toLowerCase().includes(event.query.toLowerCase()))
            setListaVariedades(_filteredVariedades)
        }, 500)
    }

    return (
        <Dialog visible={props.visible} header={headerElement} footer={footerElement} maximizable style={{ width: '1000px', maxWidth: '100dvw' }} onHide={() => { props.setVisible(false) }} resizable position={'center'} modal>
            <Messages ref={msgs} style={{ position: 'fixed', bottom: 20, right: 280 }} />
            <ConfirmDialog />
            <Toast ref={toast} position="bottom-right" />
            <Divider align="left">
                <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                    <MdMap style={{ marginRight: 5 }} />
                    <b>Lotes</b>
                    {/* {lotes.length > 0 && <Badge value={lotes.length} />} */}
                    {countLotes > 0 && <Badge style={{ marginLeft: 5 }} value={countLotes} />}
                </div>
            </Divider>
            <LotesSelect propriedades={props.propriedades} lotes={lotes} setCount={(value: number) => setCountLotes(value)} setPropriedade={setPropriedade} propriedade={props.propriedade} />
            <div style={{ height: 5 }} />
            {(props.config === CadastroPlantioConfig.CADASTRO_PRODUTOR) &&
                <>
                    <Divider align="left">
                        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                            <PiPlantFill style={{ marginRight: 5 }} />
                            <b>Plantio</b>
                            {plantios.length !== 0 && <Badge style={{ marginLeft: 5 }} value={plantios.length} />}
                        </div>
                    </Divider>
                    <div className="flex flex-column p-inputgroup flex-1">
                        <span className="p-inputgroup-addon"> <EventIcon /> <b>Data de Plantio</b></span>
                        <Calendar name='data' inputId='data' dateFormat={'dd/mm/yy'}
                            // minDate={new Date()}
                            value={plantio.data} onChange={changeFieldGeneric} showIcon />
                    </div>
                    {errorNome.length > 0 && <small style={{ color: 'red', paddingInlineStart: 5 }}>{errorNome}</small>}
                    <div style={{ height: 5 }} />
                    <div className="flex flex-column p-inputgroup flex-1">
                        <span className="p-inputgroup-addon"><GrassIcon /> <b>Cultura</b></span>
                        <span className="p-float-label">
                            <AutoComplete name='cultura' value={plantio.cultura} onChange={changeFieldCultura} suggestions={listaCulturas} dropdown onFocus={onFocusCultura} completeMethod={searchCultura}></AutoComplete>
                            <label htmlFor="cultura">Informe a cultura</label>
                        </span>
                    </div>
                    <div style={{ height: 5 }} />
                    <div className="flex flex-column p-inputgroup flex-1">
                        <span className="p-inputgroup-addon" style={{ width: 290, display: 'flex', justifyContent: 'left' }}><GrassIcon /> <b>Variedade (Cultivar)</b></span>
                        <span className="p-float-label">
                            <AutoComplete name='variedade' value={plantio.variedade} onChange={changeFieldVariedade} suggestions={listaVariededes} dropdown completeMethod={searchVariedade}></AutoComplete>
                            <label htmlFor="variedade">Informe a cultivar</label>
                        </span>
                    </div>
                    <div style={{ height: 5 }} />
                    <div className="flex flex-column p-inputgroup flex-1">
                        <span className="p-inputgroup-addon"><PollIcon /> <b>Produtividade</b></span>
                        <span className="p-float-label">
                            <InputNumber name='produtividade' value={plantio.produtividade} onValueChange={changeFieldGeneric} locale="pt-BR" minFractionDigits={2} maxFractionDigits={2} suffix={' t/ha'} />
                            <label htmlFor='produtividade'>Informe a produtividade em t/ha</label>
                        </span>
                    </div>
                    <div style={{ height: 5 }} />
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className="p-inputgroup">
                            <span className="p-inputgroup-addon"><GiWaterDrop /><b>Sistema de Irrigação</b></span>
                            <ToggleButton name={'irrigacao_fluvial'} onLabel={'Fluvial'} offLabel={'Fluvial'}
                                onIcon={<FaWater style={{ marginRight: 5 }} />} offIcon={<FaWater style={{ marginRight: 5 }} />}
                                checked={plantio.irrigacao_fluvial} onChange={changeFieldGeneric} />
                            <ToggleButton name={'irrigacao_poco'} onLabel={'Poço'} offLabel={'Poço'}
                                onIcon={<FaArrowUpFromWaterPump style={{ marginRight: 5 }} />} offIcon={<FaArrowUpFromWaterPump style={{ marginRight: 5 }} />}
                                checked={plantio.irrigacao_poco} onChange={changeFieldGeneric} />
                        </div>
                    </div>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'end' }}>
                        <Button icon={<AddCircleIcon />} onClick={addPlantio} disabled={lotes.length === 0||!plantio.cultura||!plantio.variedade||!plantio.data}> <b>Adicionar</b></Button>
                    </div>
                </>
            }
            <div style={{ height: 5 }} />
            <DataTable value={plantios} tableStyle={{ minWidth: '50rem' }} dataKey="id">
                <Column header="Plantio" body={plantioTemplate} ></Column>
                <Column header="Cultura" field='cultura' ></Column>
                <Column header="Cultivar" field='variedade'></Column>
                <Column header="Produtividade" body={produtividadeTemplate}></Column>
                <Column header="Irrigação" body={irrigacaoTemplate}></Column>
                <Column header="Lotes" body={lotesTemplate}></Column>
                <Column body={actionBodyTemplate} exportable={false} style={{ width: '5rem' }}></Column>
            </DataTable>
            <div style={{ height: 5 }} />
            <Divider align="left">
                <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                    <PiIdentificationBadgeFill style={{ marginRight: 5 }} />
                    <b>Responsável Técnico</b>
                </div>
            </Divider>
            <InputCpfCnpj value={campoCpfCnpj} setValue={onCpfCnpjSetValue} labelIcon={<BadgeIcon />}
                label={tipoRT.toUpperCase()} onModeChange={setTipoRT} onComplete={completeFieldCPF}
                labelStyle={{ width: '6rem' }} />
            <div style={{
                border: '1px solid #ced4da',
                display: cpfNome.length ? 'block' : 'none',
                paddingInline: 'inherit'
            }}>{cpfNome}</div>
            <div style={{ height: 5 }} />
            {(props.config !== CadastroPlantioConfig.CADASTRO_PRODUTOR) &&
                <>
                    <div className="p-inputgroup flex-1">
                        <span className="p-inputgroup-addon"><InsertDriveFileIcon /><b>DRT</b></span>
                        <InputNumber id='resp' name='responsavel_tecnico'
                            value={drt}
                            onChange={changeFieldDRT}
                            useGrouping={false}
                            disabled={props.config !== CadastroPlantioConfig.APROVACAO_RT}
                        />
                    </div>
                    <div style={{ height: 5 }} />
                    <DocumentFileUpload
                        label="Documento de Responsabilidade Técnica"
                        icon={<InsertDriveFileIcon />}
                        initialFile={files[0]}
                        onFileSelect={(file) => setFiles(file ? [file] : [])}
                        editMode={props.config !== CadastroPlantioConfig.APROVACAO_RT}
                    />
                </>
            }
        </Dialog >
    );
}